import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  ScrollView,
  Dimensions,
  Platform,
  TouchableHighlight,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import * as Actions from "../actions/ElevatorActions";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";

import Theme from "../argon-ui/Theme";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faTrash, faPlus, faEdit } from "../../assets/consts/faCharCodes";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import PropTypes from "prop-types";
import Loading from "../components/Loading";
import InputSpinner from "react-native-input-spinner";
import InputBase from "../nativeBase-ui/InputBase";
import { HStack } from "native-base";

/**@augments{Component<props,state>} */
class ElevatorFloor extends Component {
  static propTypes = {
    id: PropTypes.number,
    uId: PropTypes.string,
    label: PropTypes.string,
    floorLevel: PropTypes.number,
    onNameChange: PropTypes.func,
    onLevelChange: PropTypes.func,
    onDelete: PropTypes.func,
  };
  constructor(props) {
    super(props);
    let { id, uId, name, level } = this.props;
    this.state = {
      id,
      uId,
      label: name,
      floorLevel: level,
      firstFloor: 0,
    };
  }

  handleOnNameChange = (label) => {
    this.setState({ label }, () => {
      this.props.onNameChange && this.props.onNameChange(label);
    });
  };
  handelOnLevelChange = (floorLevel) => {
    this.setState({ floorLevel }, () => {
      this.props.onLevelChange && this.props.onLevelChange(floorLevel);
    });
  };
  handleOnDelete = () => {
    this.setState({ id: 0, uId: null, label: "", floorLevel: 1 });
    this.props.onDelete && this.props.onDelete(this.state.uId, this.state.id);
  };
  render() {
    return (
      <View
        style={{
          flexDirection: "row",
          marginVertical: 5,
          padding: 5,
          alignItems: "center",
          borderColor: Theme.COLORS.BORDER_COLOR,
          borderWidth: 2,
          borderRadius: 10,
          backgroundColor: Theme.COLORS.WHITE,
        }}
      >
        <View style={{ flex: 1 }}>
          <View
            style={{
              paddingTop: 2,
              paddingStart: 3,
              alignItems: "flex-end",
              padding: 5,
              marginTop: Platform.OS == "web" ? -5 : 0,
            }}
          >
            <TouchableHighlight
              underlayColor="transparent"
              style={{
                width: 40,
                height: 40,
                backgroundColor: Theme.COLORS.ERROR,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 5,
              }}
              onPress={this.handleOnDelete}
            >
              <FontAwesomeIcon icon={faTrash} color="#FFF" size={16} />
            </TouchableHighlight>
          </View>
          <View
            style={{
              flex: 1,
              // width: 150,
              flexDirection: "row",
              marginTop: Platform.OS == "web" ? -20 : 0,
            }}
          >
            <InputBase
              containerStyle={{
                backgroundColor: Theme.COLORS.LIGHT_MAIN,
                width: 200,
              }}
              placeholder={translate("elevator.floorLabel")}
              label={translate("elevator.floorLabel")}
              onChangeText={(txt) => this.handleOnNameChange(txt)}
              value={this.state.label}
              icon={faEdit}
            />
            <View
              style={{
                marginTop: 30,
                marginEnd: 22,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <InputSpinner
                value={this.state.floorLevel}
                onChange={(value) => this.handelOnLevelChange(value)}
                // minValue={this.state.firstFloor}
                totalWidth={100}
                totalHeight={40}
                iconSize={50}
                min={0}
                step={1}
                skin="round"
                buttonFontSize={14}
                fontSize={14}
                style={{ height: 40, width: 130 }}
                height={40}
                width={100}
              />
            </View>
          </View>
        </View>
      </View>
    );
  }
}

class ElevatorFormScreen extends Component {
  constructor(props) {
    super(props);
    let deviceId = undefined;
    let deviceUId = undefined;
    if (this.props.navigation.state.params) {
      deviceId = this.props.navigation.state.params.deviceId;
      deviceUId = this.props.navigation.state.params.deviceUId;
      // let areaId = undefined;
      // areaId = this.props.navigation.state.params.areaId;
    }
    this.state = {
      deviceId: deviceId || 0,
      deviceUId: deviceUId || null,
      accessToken: "",
      isLoading: true,
      isOutOfService: false,
      elevatorId: 0,
      elevatorUId: null,
      elevatorName: "",
      elevatorFloors: [{ id: 0, uId: null, label: "", floorLevel: 0 }],
      miss_elevatorName: false,
      hardWareCode: null,
      showOnHomeScreen: false,
      hasVIP: false,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  componentDidMount() {
    if (this.props.navigation.state.params) {
      let { deviceId, deviceUId, duplicateFromId } =
        this.props.navigation.state.params;
      if (deviceId || deviceUId) {
        for (var i in this.props.reducer.list) {
          var device = this.props.reducer.list[i];
          if (device.deviceType == "ELEVATOR")
            if (device.deviceId == deviceId || device.deviceUId == deviceUId) {
              this.setState({
                elevatorFloors: device.elevatorFloors,
                isLoading: false,
                isOutOfService: device.isOutOfService || false,
                elevatorId: device.id,
                elevatorUId: device.uId,
                elevatorName: device.name,
                hardWareCode: device.hardWareCode,
                showOnHomeScreen: device.showOnHomeScreen || false,
                hasVIP: device?.hasVIP || false,
              });
            }
        }
      } else if (duplicateFromId) {
        for (var i in this.props.reducer.list) {
          var device = this.props.reducer.list[i];
          if (device.deviceType == "ELEVATOR")
            if (device.deviceId == deviceId) {
              this.setState({
                elevatorFloors: device.elevatorFloors,
                isLoading: false,
                isOutOfService: device.isOutOfService || false,
                elevatorId: 0,
                elevatorName: device.name,
                hardWareCode: device.hardWareCode,
                hasVIP: device?.hasVIP || false,
              });
            }
        }
      } else {
        //new elevator
        this.setState({
          isLoading: false,
        });
      }
    } else {
      this.setState({ isLoading: false });
    }
    this.getAccessTokenAsync();
  }
  getAccessTokenAsync = async () => {
    if (!this.state.accessToken) {
      try {
        var { accessToken } = this.props.appReducer.currentServer;
        this.setState({ accessToken });
      } catch (err) {
        console.log(err);
      }
    }
  };

  addFloor() {
    let { elevatorFloors } = this.state;
    var newFloor = { id: 0, uId: null, label: "", floorLevel: 0 };
    if (elevatorFloors.length > 0) {
      var prevFloor = elevatorFloors.slice(-1)[0];
      newFloor.floorLevel = prevFloor.floorLevel + 1;
      if (Number(prevFloor.label)) {
        newFloor.label = (Number(prevFloor.label) + 1).toString();
      }
    }
    elevatorFloors.push(newFloor);
    this.setState({ elevatorFloors });
  }

  goBack = () => {
    this.props.navigation.goBack();

    // callback
    this.props.navigation.state.params.onGoBack &&
      this.props.navigation.state.params.onGoBack(DeviceTypes.ELEVATOR);
  };
  save = () => {
    let {
      deviceId,
      deviceUId,
      elevatorName,
      elevatorFloors,
      hardWareCode,
      isOutOfService,
      showOnHomeScreen,
      hasVIP,
    } = this.state;
    var model = {
      deviceId,
      deviceUId,
      isOutOfService,
      id: this.state.elevatorId,
      uId: this.state.elevatorUId || null,
      elevatorName,
      elevatorFloors,
      hardWareCode,
      showOnHomeScreen,
      hasVIP,
      buildingId: this.props.appReducer.currentBuilding.buildingId,
    };

    let errors = [];
    if (!model.elevatorName) {
      errors.push(
        `${translate("elevator.elevatorName")} ${translate("app.isRequired")}`
      );
    }
    if (errors.length > 0) {
      alert(errors.join("\r\n"));
      return;
    }
    if (model.uId || model.id) {
      this.props.update(model, this.state.accessToken);
    } else {
      this.props.add(model, this.state.accessToken);
    }
    this.goBack();
  };

  render() {
    const screenTitle =
      this.state.elevatorUId || this.state.elevatorId
        ? this.state.elevatorName || translate("app.noName")
        : translate("elevator.createNewElevator");
    if (this.state.isLoading) {
      return <Loading />;
    }
    return (
      <KeyboardAvoidingView
        behavior="padding"
        style={{ flex: 1 }}
        enabled={true}
        keyboardVerticalOffset={80}
      >
        <ScrollView style={style.container}>
          <Text style={style.screenTitle}>{screenTitle}</Text>
          {/* Elevator name */}
          <InputBase
            isInvalid={this.state.miss_elevatorName}
            label={translate("elevator.elevatorName")}
            onChangeText={(txt) =>
              this.setState({
                elevatorName: txt,
                miss_elevatorName: txt.length == 0,
              })
            }
            value={this.state.elevatorName}
            icon={faEdit}
          />
          {/* end Elevator name */}
          {/* hardware code */}
          <View style={{ marginVertical: 15 }}>
            <InputBase
              label={translate("elevator.hardWareCode")}
              onChangeText={(txt) =>
                this.setState({
                  hardWareCode: txt,
                })
              }
              value={this.state.hardWareCode}
              icon={faEdit}
            />
          </View>
          {/* hardware code */}
          {/* showOnHomeScreen */}
          {this.state.showOnHomeScreen != undefined && (
            <View style={{ flexDirection: "row", marginTop: 15 }}>
              <Switch
                isOn={this.state.showOnHomeScreen}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  this.setState({ showOnHomeScreen: v });
                }}
                animationSpeed={0}
              />
              <Text style={{ marginHorizontal: 5 }}>
                {translate("device.showOnHomeScreen")}
              </Text>
            </View>
          )}
          {/* end showOnHomeScreen */}
          {/* isOutOfService */}
          {this.state.isOutOfService != undefined && (
            <View style={{ flexDirection: "row", marginTop: 15 }}>
              <Switch
                isOn={this.state.isOutOfService}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  this.setState({ isOutOfService: v });
                }}
                animationSpeed={0}
              />
              <Text style={{ marginHorizontal: 5 }}>
                {translate("elevator.isOutOfService")}
              </Text>
            </View>
          )}

          {this.state.isOutOfService == true && (
            <Text style={{ color: Theme.COLORS.MUTED }}>
              {translate("elevator.outOfServiceHint")}
            </Text>
          )}
          {/* === VIP mode === */}
          {/* {this.state.hasVIP && ( */}
          <View style={{ flexDirection: "row", marginTop: 15 }}>
            <Switch
              isOn={this.state.hasVIP}
              onColor={Theme.COLORS.ACTIVE}
              offColor={Theme.COLORS.MUTED}
              size="small"
              onToggle={(v) => {
                this.setState({ hasVIP: v });
              }}
              animationSpeed={0}
            />
            <Text style={{ marginHorizontal: 5 }}>
              {translate("elevator.VIPMode")}
            </Text>
          </View>
          {/* )} */}
          {/* start of add and delete floors*/}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Text
              style={{
                height: 30,
                textAlignVertical: "center",
                paddingTop: 12,
              }}
            >
              {translate("elevator.floors")}
            </Text>
          </View>

          {this.state.elevatorFloors.map((chn, idx) => {
            return (
              <ElevatorFloor
                key={idx}
                level={chn.floorLevel}
                name={chn.label}
                onNameChange={(name) => {
                  let _elevatorFloors = [...this.state.elevatorFloors];
                  _elevatorFloors[idx].label = name;
                  this.setState({ elevatorFloors: _elevatorFloors });
                }}
                onLevelChange={(level) => {
                  let _elevatorFloors = [...this.state.elevatorFloors];
                  _elevatorFloors[idx].floorLevel = level;
                  this.setState({ elevatorFloors: _elevatorFloors });
                }}
                onDelete={() => {
                  let _elevatorFloors = [...this.state.elevatorFloors];
                  _elevatorFloors.splice(idx, 1);
                  if (_elevatorFloors.length == 0) {
                    _elevatorFloors = [];
                  }
                  this.setState({ elevatorFloors: _elevatorFloors });
                }}
              />
            );
          })}
          <ArButton
            color="success"
            style={{
              width: 100,
              alignSelf: "flex-start",
              marginEnd: 5,
              marginStart: 10,
              marginTop: 15,
            }}
            onPress={() => {
              this.addFloor();
            }}
          >
            <View
              style={{
                flexDirection: "row-reverse",
              }}
            >
              <FontAwesomeIcon icon={faPlus} color="#FFF" />
            </View>
          </ArButton>

          {/* end of add and delete floors*/}
          {/*/start of goBack and save button */}
          <HStack
            space={2}
            style={{
              marginTop: 10,
            }}
          >
            <ArButton
              color="primary"
              onPress={() => this.save()}
              style={{ flex: 1 }}
            >
              {translate("app.save")}
            </ArButton>
            <ArButton
              color="muted"
              variant="outline"
              onPress={() => this.goBack()}
              style={{ flex: 1 }}
            >
              {translate("app.goBack")}
            </ArButton>
          </HStack>
          {/*/end of goBack and save button */}
        </ScrollView>
      </KeyboardAvoidingView>
    );
  }
}

const btnStyle = {
  flex: 1,
  margin: 3,
  padding: 3,
  borderRadius: 3,
  height: 45,
  alignItems: "center",
  justifyContent: "center",
};

const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  img: {
    borderColor: "#eee",
    borderWidth: 1,
    borderRadius: 15,
    // marginHorizontal: 'auto',
    marginVertical: 5,
    resizeMode: "cover",
    alignSelf: "center",
    width: Dimensions.get("window").width,
    height: Dimensions.get("window").width * (9 / 16),
  },
  txtInput: {
    borderWidth: 1,
    borderColor: "navy",
  },
  btnPickImage: {
    ...btnStyle,
    borderWidth: 1,
    borderColor: "#ddd",
    backgroundColor: "#FFF",
    width: "100%",
  },
  btnPickImageAr: {
    // marginVertical: 3
    height: 45,
  },
  btnPickImageGroup_Show: {
    position: "absolute",
    flex: 1,
    alignItems: "center",
    width: "100%",
    height: "100%",
    paddingVertical: 10,
    justifyContent: "space-around",
    backgroundColor: "#FFFA",
  },
  btnPickImageGroup_Hide: {
    display: "none",
  },

  btnDevices: {
    flex: 1,
    marginTop: 10,
    width: "100%",
  },
  dropdownWrapper: { marginTop: 16 },
  dropdownButton: {
    width: "100%",
    backgroundColor: "#FFF",
    borderColor: Theme.COLORS.BORDER,
    borderWidth: 1,
    marginTop: 6,
    shadowColor: Theme.COLORS.BLACK,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 2,
    shadowOpacity: 0.05,
    elevation: 2,
  },
  dropdownButtonText: { color: "#000", paddingVertical: 5 },
  dropdownMenu: { width: "80%", elevation: 3 },
  dropdownMenuText: { paddingVertical: 22 },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (model, accessToken) => {
      dispatch(Actions.Add(model, accessToken));
    },
    update: (model, accessToken) => {
      dispatch(Actions.Update(model, accessToken));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ElevatorFormScreen);
